import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import axios from "axios";
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CampusesSection.css';
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const CampusesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- SCHOOL LIST ---------------- */
  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/general_settings/get_schools/`,
        { withCredentials: true }
      );

      if (res.data.status === 1 && res.data.data) {
        setSchools(res.data.data || []);
        console.log(schools);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const settings = isMobile ? {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: false,
    centerMode: false,
    variableWidth: false
  } : {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000
        }
      }
    ]
  };




  return (

    <section ref={sectionRef} className="campuses-section">
      <div className="campuses-container">
        <h2 className="campuses-title">OUR CAMPUSES</h2>
        <p className="campuses-subtitle">
          Explore our {schools.length} schools across West Bengal
        </p>

        {schools.length > 0 ? (
          <Slider {...settings} className="campuses-slider">
            {schools.map((school, index) => (
              <div key={index} className="campus-slide">
                <div className="campus-card">
                  <div className="campus-image">
                    <img src={`${baseAPIUrl}assets/images/schools/${school.school_image}`} alt={school.name} />
                  </div>
                  <div className="campus-content">
                    <h3 className="campus-name">{school.school_name}</h3>
                    <Link to={`/${school.school_slug}`} className="campus-cta" target='_blank'>
                      Explore Campus
                      <i className="fas fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <p style={{ textAlign: "center", color: "rgb(100, 19, 32)", margin: "40px 0" }}>
            {loading ? "Loading campuses..." : "No campuses available"}
          </p>
        )}

        <div className="campuses-view-all">
          <Link to="/schools" className="view-all-btn-school" >
            View All Schools
          </Link>
        </div>
      </div>
    </section>

  );
};

export default CampusesSection;
